/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { unitType } from "../../../util/unitType";
import { reformatData } from "../../../util/helperFunctions";
import { ErrorContext } from "../../../App";
import { toast } from "react-toastify";
import { inferDate } from "../../../components/MetricChart/useMetricChartHook";
import { calculateForecastWT, forecastWTExpression } from "../../../api/sensorApi";
import moment from "moment";

import * as R from "rambda";

function useForecastWallThickness({
    sensorID,
    start,
    end,
    sensorCheckboxes,
    interval,
    forecastMonths,
    isNorco,
    units,
    PredictedWallThicknessMetric,
}) {

    const errorContext = useContext(ErrorContext);
    const [isForecastWallThickness, setIsForecastWallThickness] = useState(false);
    const [lifeExpectancy, setLifeExpectancy] = useState(null);
    const [forecast_wallthickness, setForecastWallThickness] = useState(null);
    const [forecastWallThicknessLoading, setForecastWallThicknessLoading] = useState(false);

    useEffect(() => {
        if (sensorCheckboxes.ForecastWallThickness.enabled) {
            setIsForecastWallThickness(true);
            setForecastWallThicknessLoading(true);
            calculateForecastWT({
                sensor_id: sensorID,
                selectedStartDate: moment(start).format("YYYY-MM-DD"),
                selectedEndDate: moment(end).format("YYYY-MM-DD"),
                forecastMonths: forecastMonths.value,
            })
                .then((result) => {
                    if (result?.status === 'error') {
                        errorContext.showAlert(result?.errorMessage);
                    }
                    setLifeExpectancy(+result?.data?.lifeExpectancyInYears + end.year());
                    return forecastWTExpression({
                            sensor_id: sensorID,
                            start: moment(result?.data?.lastPredictedCRDate).format("YYYY-MM-DD"),
                            end: moment(result?.data?.forecastEndDate).format("YYYY-MM-DD"),
                            lastPredictedWallThickness: result?.data?.lastPredictedWallThickness,
                            meanCorrosionRate: result?.data?.meanCorrosionRate,
                            units: unitType(units, "length"),
                        });
                })
                .then((forecast_data) => {

                    forecast_data = reformatData([forecast_data])[0];
                    let forecastValue = {};
                    const objData =
                        forecast_data && forecast_data.result
                            ? forecast_data.result[sensorID]
                            : {};
                    Object.keys(objData).forEach((propName) => {
                        if (propName.includes("ForecastedWallThickness")) {
                            forecastValue = objData[propName];
                        }
                    });
                    const forecastDates = forecastValue?.data.map((val, i) => inferDate(forecastValue.start, forecastValue.interval, i));
                    const forecastMetricData = [
                        {
                            y: R.path(["data"], forecastValue),
                            x: forecastDates,
                            name: "Forecasted Wall Thickness",
                            text: `[(${R.path(
                                ["unit", "symbol"],
                                forecastValue
                            )})]`,
                            hovertemplate: `%{y} [${R.path(
                                ["unit", "symbol"],
                                forecastValue
                            )}]`,
                            showlegend: true,
                            mode: "lines",
                            line: {
                                color: "#00525E",
                            },
                        },
                    ];
                    setForecastWallThickness(forecastMetricData);
                }).catch((error) => { console.log(error); toast.error("Error fetching forecast data") })
                .finally(() => {
                    setForecastWallThicknessLoading(false);
                });
        } else {
            setIsForecastWallThickness(false);
            setForecastWallThickness(null);
            setForecastWallThicknessLoading(false);
        }
    }, [
        sensorID,
        start,
        end,
        sensorCheckboxes,
        interval.value,
        forecastMonths,
        isNorco,
        units,
        PredictedWallThicknessMetric,
    ]);

    return {
        isForecastWallThickness,
        lifeExpectancy,
        forecast_wallthickness,
        forecastWallThicknessLoading,
    }
}

export default useForecastWallThickness;